// extracted by mini-css-extract-plugin
export default {"container":"z_-z","tab":"A_-z","selected":"B_-z"};